import { gql } from '@apollo/client';

export const PATIENTS_FILTER = gql`
  query searchPatientsFuzzy($fuzzySearch: String, $cursor: ID, $count: Int) {
    searchPatientsFuzzy(query: $fuzzySearch, cursor: $cursor, count: $count) {
      data {
        id
        analyticsData
        signupCode
        # legacy fallback until LCX-965 backfill
        name
        nameFirst
        nameLast
        email
        progress
        sessionDate
        clinic {
          name
          displayName
        }
        clinician {
          id
          name
        }
        courseEnrollments {
          course: config {
            name
          }
          startDate
        }
      }
      cursor
    }
  }
`;
